import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';
import {RecordForm} from '../forms/RecordForm';
import {Card} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Card,
        handleSubmit: (values: Card) => void
    }) => {

    const title = record?.id ? 'Edit Card' : 'Add Card';

    const handleFormSubmit = async (values: Card) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            size="xl"
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
